import { ChangeEvent, FC } from 'react';
import { FormLabel, Switch } from '@screentone/core';

const ScratchpadToggle: FC = () => {
  const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
    localStorage.setItem('scratchpadEnabled', e.target.checked ? 'true' : 'false');
  };

  const isEnabled = localStorage.getItem('scratchpadEnabled') === 'true';

  return (
    <FormLabel label="Enable Scratch Pad" labelPosition="right">
      <Switch name="enable-scratchpad" onChange={handleToggle} defaultChecked={isEnabled} />
    </FormLabel>
  );
};

export default ScratchpadToggle;
